<script>
import deepLink from '@/mixins/deeplink.js'
import { mapState } from 'vuex'

export default {
  name: 'DeeplinkCart',
  components: {},
  mixins: [deepLink()],
  props: {
    componentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('widgets', {
      articleId: state => state.common.params.articleId,
      userOS: state => state.common.user.os,
    }),
    queryString() {
      const { componentData, userOS } = this

      // Restaurant

      if (componentData.store_type === 'restaurant' && userOS === 'iOS')
        return `store_type=${this.componentData.store_type}&brand_name=${
          this.componentData.brand_name
        }&product_id=${this.productsToString}`

      if (
        componentData.store_type === 'restaurant' &&
        (userOS === 'Android' || userOS === 'unknown')
      )
        return `store_type=${this.componentData.store_type}&productsIds=${
          this.productsToString
        }&brand_name=${this.componentData.brand_name}&orderId=${
          this.componentData.order_id
        }`

      // Market

      if (this.componentData.store_type === 'market')
        return `store_type=${this.componentData.store_type}&market_type=${
          this.componentData.market_type
        }&product_id=${this.productsToString}`

      return ''
    },
    productsToString() {
      return this.componentData.products.join()
    },
  },
  created() {},
  methods: {
    getImgUrl: function(name) {
      var image = require.context('@assets/images/', false, /\.png$/)
      return image('./' + name + '.png')
    },
  },
}
</script>

<template>
  <div :class="$style.container">

    <div :class="$style.container__info">
      <img
        :src="getImgUrl('happy-box')"
        :alt="'Happy'"
      >

      <h1>{{ $t('WIDGETS.COMMON.OK') }}</h1>
      <p>{{ $t('WIDGETS.DEEP_LINK_CART.ALREADY_APPLIED_RAPPICREDITS') }}</p>
    </div>

    <div
      v-if="userOS !== 'unknown'"
      :class="$style.container__buttons"
    >
      <BaseButton
        full
        @click="callDeepLink(queryString)"
      >
        {{ componentData.buttons[1].label }}
      </BaseButton>
      <BaseButton
        full
        alter
        @click="callDeepLink('goto=home')"
      >
        {{ componentData.buttons[0].label }}
      </BaseButton>
    </div>
  </div>
</template>


<style lang="scss" scoped module>
@import '@design';

.container {
  display: flex;
  flex-flow: column wrap;
  padding: 0.5rem 0;

  &__info {
    padding: 1rem;
    img {
      max-width: 9rem;
      max-height: 9rem;
      margin: 2rem;

      @include responsive(phone) {
        max-width: 13rem;
        max-height: 13rem;
      }
    }

    h1 {
      margin: 0.5rem 0;
      font-size: 3rem;
      font-weight: 900;
    }

    p {
      @extend %typography-medium;
    }
  }

  &__buttons {
    width: 100%;
    margin: 2rem 0 0 0;

    > button {
      margin-top: 1rem;
      &:focus {
        outline: 0;
      }
    }
  }
}
</style>
